import { Button } from '@mui/material';
import React from 'react';
import * as S from './styles';

interface Props {
  children?: React.ReactNode;
  onButtonClick?: () => void;
  headTitle?: string;
  disabled: boolean;
  text?: string; 
}

const Wrapper = ({ children, onButtonClick, headTitle, disabled, text }: Props) => {
  return (
    <S.Wrapper component="div">
      <S.Head>{headTitle}</S.Head>

      <S.Content>{children}</S.Content>

      <S.Footer>
        <Button
          variant="contained"
          disabled={disabled}
          onClick={onButtonClick}
          size="large"
        >
          {text || 'Speichern'}
        </Button>
      </S.Footer>
    </S.Wrapper>
  );
};

export default Wrapper;
